import { createFileRoute, redirect } from '@tanstack/react-router'
import { DepreciationRunScreen } from '@/features/accounting-assets/depreciation-run-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/assets/depreciation')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_asset_depreciation.create')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: DepreciationRunScreen,
})
